module.exports = __webpack_public_path__ + "assets/Unknown.69847f02.svg";